import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { TradeIn } from "Types/TradeIn";

export const openTradeIn = actionCreator("trade_in/modal/open", (vin: string) => ({
    vin,
}));

export const closeTradeIn = actionCreator("trade_in/modal/close");

export const toggleTradeInDrawer = actionCreator("trade_in/drawer/toggle");

export const toggleTradeInEstimateModeManual = actionCreator("trade_in/toggle_estimate_mode/manual");

export const toggleTradeInVehicleModeDefault = actionCreator("trade_in/toggle_vehicle_mode/default");

export const toggleTradeInVehicleModeFallback = actionCreator("trade_in/toggle_vehicle_mode/fallback");

export const patchTradeInRequest = actionCreator(
    "trade_in/patch/request",
    (
        tradeIn: TradeIn,
        uuid: string,
    ) => ({
        tradeIn,
        uuid,
    }),
    (
        tradeIn: TradeIn,
        uuid: string,
        eventName?: "start_trade_in" | "finish_trade_in",
        eventTradeInType?: "manual"
    ) => ({
        route: API.TradeIn,
        analytics: { eventName, eventTradeInType },
    })
);

export const patchTradeInSuccess = actionCreator("trade_in/patch/success", (tradeIn: TradeIn) => ({ tradeIn }));

export const patchTradeInFailure = actionCreator("trade_in/patch/failure");

export const deleteTradeInRequest = actionCreator(
    "trade_in/delete/request",
    (uuid: string, reset: boolean = false) => ({ uuid, reset }),
    () => ({ route: API.TradeIn })
);

export const deleteTradeInSuccess = actionCreator("trade_in/delete/success");

export const deleteTradeInFailure = actionCreator("trade_in/delete/failure");
